module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '虚拟币设置'
    }
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("虚拟币类型")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("汇率设置")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    staticClass: "tab-main"
  }, [_c('div', {
    staticClass: "back-list page"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("虚拟币名称")]), _vm._v(" "), _c('div', [_vm._v("虚拟币描述")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, _vm._l((_vm.currencyList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(item.currency_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.description))])])
  }))], 1)]), _vm._v(" "), _c('rate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    staticClass: "tab-main"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f7ee1da0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-currency.vue
// module id = 798
// module chunks = 1